import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './cbpAuthPdfInitialState';
import { _setCbpAuthPdfPrint } from './cbpAuthPdfActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpAuthPdfForm = createAsyncThunk(
  'stop/getCbpAuthPdfForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const cbpAuthPdfSlice = createSlice({
  name: 'stop/cbpAuthPdfForm',
  initialState,
  reducers: {
    setCbpAuthPdfPrint: _setCbpAuthPdfPrint,
    resetCbpAuthPdfForm: () => initialState,
  },
  extraReducers: {
    [getCbpAuthPdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setCbpAuthPdfPrint, resetCbpAuthPdfForm } =
  cbpAuthPdfSlice.actions;

export default cbpAuthPdfSlice.reducer;
